import ImportCustomTablesModal from 'modules/employees/components/ImportCustomTablesModal'
import { useOnCloseGoToList } from 'modules/employees/hooks/useOnCloseGoList'
import { useEmployeesImporter } from 'modules/employees/lib/employeesImporterContext'

const ImportCustomTablesModalPage = () => {
  const onClose = useOnCloseGoToList()
  const importer = useEmployeesImporter()

  return <ImportCustomTablesModal onClose={onClose} importer={importer} />
}

export default ImportCustomTablesModalPage
